// extracted by mini-css-extract-plugin
export default {"ag-styles":"G_y","detailCellRenderer":"G_c6"};